import { TransportMode } from '../../../../common/constants';
import { ShipmentLoadToGpsPointModel } from '../../../models/shipment-load-to-gps-point.model';

export class ShipmentTransportOrderMapData {
  gpsPoints: ShipmentLoadToGpsPointModel[];
  transportMode: TransportMode;
}
